import React from "react";
import { ShieldCheck, FileText, AlertCircle, ChevronRight } from "lucide-react";
import { OfficeHoursChips, LandingRightsChip } from "@/components/cbp/CBPShared";

// US CBP info — shown only when the destination matches a published CBP
// fact-sheet airport AND the origin is outside the US. The `is_international`
// flag auto-flips on in the same effect that populates this card. Chips
// reuse the CBP page's parsers so the ops manager sees the same condensed
// reading (e.g. "M-F . 08:00-17:00 . ET" rather than the full raw sentence).
export default function CbpInfoCard({ leg, legIndex, baseForTz, t, onOpenDetails, onOpenPdf }) {
  if (!leg.cbp_info) return null;
  return (
    <div className="bg-sky-500/5 border border-sky-500/25 rounded-lg px-3 py-2.5">
      <div className="flex items-center justify-between gap-2 mb-1.5">
        <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider text-sky-400">
          <ShieldCheck className="w-3 h-3" />
          <span>US CBP · {leg.cbp_info.icao}</span>
          {leg.cbp_info.iata && (
            <span className="text-slate-500 font-mono normal-case tracking-normal">
              {leg.cbp_info.iata}
            </span>
          )}
        </div>
        {leg.cbp_info.icao && (
          <button
            type="button"
            onClick={() => onOpenPdf(legIndex)}
            className="text-[10px] px-1.5 py-0.5 bg-sky-700/80 hover:bg-sky-600 rounded font-medium flex items-center gap-1 transition text-white"
            title={t("cbp.viewPdf")}
          >
            <FileText className="w-2.5 h-2.5" /> PDF
          </button>
        )}
      </div>
      {leg.cbp_info.office_hours && (
        <OfficeHoursChips raw={leg.cbp_info.office_hours} t={t} base={baseForTz} />
      )}
      {leg.cbp_info.ptl_lead_time && <LandingRightsChip raw={leg.cbp_info.ptl_lead_time} t={t} />}
      <p className="mt-2 text-[10px] text-amber-400/80 leading-snug flex items-start gap-1.5">
        <AlertCircle className="w-3 h-3 flex-shrink-0 mt-0.5" />
        <span>{t("cbp.officialPdfDisclaimer")}</span>
      </p>
      <button
        type="button"
        onClick={() => onOpenDetails(legIndex)}
        className="mt-2 text-[11px] text-sky-400 hover:text-sky-300 flex items-center gap-0.5 transition"
      >
        {t("cbp.fullDetails")} <ChevronRight className="w-3 h-3" />
      </button>
    </div>
  );
}
